import styled from 'styled-components';

export const CancelButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
`;
